// Angular
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

// Libraries
import { addSeconds, intervalToDuration } from 'date-fns';
import { takeUntil } from 'rxjs';

// Models
import { Job } from '../../modules/job/models';
import { RunningFootage, RunningFootageGap } from '../../modules/job/models/job-return-cache.model';
import { AppCleanup } from '../../shared/models';

// Helpers
import { DateHelper } from '../../shared/helpers';

// Services
import { JobDataService } from '../../shared/workers/job-data.service';

import { SpinnerSizeType } from '../../shared/components';
@Component({
	selector: 'running-footage-dialog',
	templateUrl: './running-footage-dialog.component.html',
	styleUrls: ['./running-footage-dialog.component.scss'],
})
export class RunningFootageDialogComponent extends AppCleanup implements OnInit, OnDestroy {
  readonly SpinnerSizeType = SpinnerSizeType;
	componentTitle: string = 'Running Footage';
	job: Job;
	upid: number;
	runningFootage: RunningFootage;
	showSpinner: boolean = true;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data,
		private jobDataService: JobDataService
	) {
		super();
	}

	ngOnInit() {
		this.job = this.data.job;
		this.jobDataService
			.getRunningFootage(this.job.key)
			.pipe(takeUntil(this.destroy))
			.subscribe((data) => {
				this.runningFootage = data;
				this.showSpinner = false;
			});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	getFormattedTime(date: Date): string {
		return DateHelper.format(new Date(date), 'HH:mm');
	}

	getFormattedDuration(gap: RunningFootageGap): string {
		const start: Date = new Date(gap.start);
		const end: Date = addSeconds(start, gap.secondsDuration);
		const { hours, minutes, seconds } = intervalToDuration({ start, end });
		let formattedDuration: string[] = [];

		if (hours) formattedDuration.push(`${hours} hours`);
		if (minutes) formattedDuration.push(`${minutes} mins`);
		if (seconds) formattedDuration.push(`${seconds} secs`);

		return formattedDuration.join(', ');
	}
}
